// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[3].use[2]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[3].use[3]!../../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[3].use[4]!./today.module.scss");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, "._12129f{margin-top:0 !important;padding:0 !important}.a21531{position:absolute;overflow:hidden;top:0;right:1rem;bottom:0;left:var(--left-gutter)}.da0904{flex:1;position:relative;display:flex;flex-direction:column}.da0904>div{display:flex;align-items:center;justify-content:center}._735e51{cursor:pointer;font-weight:600;min-height:5rem;flex-direction:column;color:var(--secondary);border-bottom:1px solid var(--subtle)}._735e51 small{font-weight:500;opacity:.875;color:var(--secondary)}._733a6c{color:var(--primary)}.f0bf5c{}.d4b749{}._7752fc{}._75476e{}.ad7ff1{font-size:.75em;width:var(--left-gutter);color:var(--secondary)}.ad7ff1>*{align-items:center;display:flex;height:3rem;justify-content:flex-end;margin-right:1rem}.ad7ff1 .d1ec93{height:5rem !important;position:relative}.a8aa27,._1ac5e6{color:var(--secondary);position:absolute;top:2em;left:1.5em}@media print{.a8aa27,._1ac5e6{display:none}}._1ac5e6{left:auto;right:1em}", ""]);
// Exports
exports.locals = {
	"header": "_12129f",
	"wrap": "a21531",
	"item": "da0904",
	"heading": "_735e51",
	"isSelected": "_733a6c",
	"container": "f0bf5c " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["columns"] + "",
	"exited": "d4b749 " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["exited"] + "",
	"entering": "_7752fc " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["entering"] + "",
	"exiting": "_75476e " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["exiting"] + "",
	"labels": "ad7ff1",
	"placeholder": "d1ec93",
	"chevron-left": "a8aa27",
	"chevronLeft": "a8aa27",
	"chevron-right": "_1ac5e6",
	"chevronRight": "_1ac5e6"
};
module.exports = exports;
